import { trackLink } from "../../../../../../services/analytics";
import getSingleItemProductString from "../getSingleItemProductString";
import { UPDATE_ITEM_ACTION } from "../constants";
import {
  ADOBE_SAVED_ITEM_ACTION_KEY,
  ADOBE_PRODUCTS_KEY
} from "../../../../../../services/analytics/constants";
import { ITEMS_TYPE_CUSTOMER_ITEMS } from "../../constants";
import getFulfilmentIds from "../../../../../../getFulfilmentIds";

export const updateItem = (
  getEvents,
  state,
  {
    payload: {
      fulfilment: { source, seller },
      variantId,
      ...rest
    }
  }
) => {
  const { itemsType } = state;
  if (itemsType !== ITEMS_TYPE_CUSTOMER_ITEMS) return state;

  if (variantId === null) return state;

  const { sourceId, sellerId } = getFulfilmentIds({ source, seller });

  const events = getEvents({
    sourceId,
    sellerId,
    ...rest
  });

  const newState = {
    ...state,
    trackLink: {
      products: getSingleItemProductString({
        variantId,
        quantity: 1,
        source,
        seller
      }),
      savedItemAction: UPDATE_ITEM_ACTION,
      events,
      vars: [ADOBE_SAVED_ITEM_ACTION_KEY, ADOBE_PRODUCTS_KEY]
    }
  };

  trackLink({ state: newState });

  return newState;
};
